import { zServiceVehicleCommonSchema } from "./serviceVehicle.common";
// DTO схема для ServiceVehicle
export const zServiceVehicleSchemaDto = zServiceVehicleCommonSchema;
export const zServiceVehicleSchemaCreateDto = zServiceVehicleSchemaDto.omit({
    id: true,
});
